// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const UsageBucket = zod.object({
  "cost_usd": zod.string(),
  "key": zod.string(),
  "label": zod.string(),
  "runs": zod.int(),
  "tokens_input": zod.int(),
  "tokens_output": zod.int()
});

export type UsageBucket = zod.input<typeof UsageBucket>;
export type UsageBucketOutput = zod.output<typeof UsageBucket>;
